import { API } from 'aws-amplify';
import awsConfig from 'config/awsConfig';
import { webSocket } from 'rxjs/webSocket';
import { handleError } from 'utils/sliceUtils';
import { current } from '@reduxjs/toolkit';

export const fetchLivenessSession = async () => {
  return API.get('LivenessAPI', '/start-liveness');
};

export const fetchLivenessResult = async (sessionId) => {
  const request = { queryStringParameters: { sessionId } };
  return API.get('LivenessAPI', '/liveness-result', request);
};

export async function compareFaces(data) {
  const params = {
    headers: { 'x-sckey-token': 'oy8vCKlBJYm5ErD2tX1p6wEkcZT7E4zN3QI8P73DrBxld1MnEgkA//NlqojQ9bG5aqEXpJerau6TQ+aRoqfbAr7ujBov7nNdCo4K03HRq+/gXyweWK5ZAQMN2prydq7h09yD3Hd/RnV61KZg7XTaTw==' },
    body: { logic: 'FaceComparison', s3Data: data }
  };
  return API.post('RecognitionAPI', '/rekognitionService', params);
}

export async function extractText(data, parameters) {
  const additionalParameters = [parameters.documentId, parameters.name, parameters.lastName, parameters.idExpeditionDate];
  const textParams = {
    headers: { 'x-sckey-token': 'oy8vCKlBJYm5ErD2tX1p6wEkcZT7E4zN3QI8P73DrBxld1MnEgkA//NlqojQ9bG5aqEXpJerau6TQ+aRoqfbAr7ujBov7nNdCo4K03HRq+/gXyweWK5ZAQMN2prydq7h09yD3Hd/RnV61KZg7XTaTw==' },
    body: { logic: 'TextExtract', s3Data: data, additionalParameters } };
  return API.post('RecognitionAPI', '/rekognitionService', textParams);
}

export async function sendOtp(data) {
  const params = {
    headers: { 'x-sckey-token': 'Y/0/yjfP13KZmiQyys+hW07Wj8PH32AaF75T64cMsHsbaCPsorboS/MBEmzmTuprl+kjbQg7RC+47SaLFltNM/T/79hLn3Oalm1gCiIlBmQ=' },
    body: {
      verificationAlias: 'MobileNumberVerifyOTP',
      synchronous: true,
      documentType: 'CC',
      id: data.extractedData.cedula,
      additionalParameters: { primerApellido: data.extractedData.apellidos.split(' ')[0] },
    },
  };

  return API.post('ValidationAPI', '/executeValidation', params);
}

export async function sendOtpDirect(params) {
  const { phone, country } = params;
  const request = { body: { phone, countryCode: country.code } };
  return API.post('MessagingAPI', '/send-otp', request);
}

export function sendResults(state) {
  const { params, comparisonResult, textExtractResult, faceResult } = current(state);
  
  if (params.uuid) {
    const wssUrl = awsConfig.API.endpoints.find((endpoint) => endpoint.name === 'CallbackAPI').endpoint + `?room=${params.uuid}`;
    const subject = webSocket(wssUrl);

    subject.subscribe({
      error: (err) => handleError(state, err),
    });

    const content = { status: 'success', result: { comparisonResult, textExtractResult, faceResult } };
    const data = JSON.stringify({ uuid: params.uuid, message: { code: 'BIOMETRICS_COMPLETED', content } });
    subject.next({ action: 'sendmessage', data });
    subject.complete();
  }
}
